<template>
  <div>
    <client-only>
      <v-app class="app principal__layout">
        <LayoutsHeader />
        <div class="mt-6">
          <div class="container mt-16">
            <CommonEmptyState
              :icon="getErrorIcon"
              :title="getErrorTitle"
              :text="getErrorMessage"
              :redirect="getRedirect"
            >
            </CommonEmptyState>
          </div>
        </div>
      </v-app>
    </client-only>
  </div>
</template>

<script setup>
import { useMasters } from "~/store/masters";

const nuxtApp = useNuxtApp();
const error = useError();
const masters = useMasters();
const { t } = useI18n();

const handleError = () => {
  clearError({
    redirect: "/",
  });
};

const getErrorIcon = computed(() => {
  const errorIcons = {
    401: "mdi-lock-alert-outline",
    404: "mdi-tab-search",
    500: "mdi-emoticon-sad-outline",
    default: "mdi-tooltip-question-outline",
  };

  const key = error.value.statusCode
    ? errorIcons[error.value.statusCode]
    : errorIcons.default;
  return key;
});

const getErrorTitle = computed(() => {
  const errorTitles = {
    401: "error.401.title",
    404: "error.401.title",
    500: "error.500.title",
    default: "error.title",
  };

  const statusCode = error.value?.statusCode;
  const key = statusCode ? errorTitles[statusCode] || errorTitles.default : errorTitles.default;

  // Pasamos ambas props por compatibilidad con mensajes que usan `{page}` o `{status}`.
  return t(key, { page: statusCode, status: statusCode });
});

const getErrorMessage = computed(() => {
  const errorMessages = {
    401: "error.401.text",
    404: "error.404.text",
    default: "error.default.text",
  };

  const statusCode = error.value?.statusCode;
  const key = statusCode ? errorMessages[statusCode] || errorMessages.default : errorMessages.default;

  // Pasamos ambas props por compatibilidad con mensajes que usan `{page}` o `{url}`.
  return t(key, { page: error.value?.url, url: error.value?.url });
});

const getRedirect = computed(() => {
  const basePath = nuxtApp.$i18n.locale.value === "en" ? "/en/" : "/";
  const buttonText = t("home.go");

  return {
    link: basePath,
    to: buttonText,
  };
});

onMounted(() => {
  // Enviar el error a Application Insights
  const { $appInsights } = useNuxtApp();
  if ($appInsights) {
    $appInsights.trackException({
      exception: new Error("Page does not exist"),
      properties: {
        statusCode: error.value.statusCode,
        route: error.value.url,
        user:
          JSON.parse(localStorage.getItem("profile"))?.PERSONID || "unknown",
      },
    });
  }
  masters.setGlobalLoading(false);
});
</script>
